import React from 'react';
const frictions = ['No tenés material profesional listo para una charla, taller o actividad.', 'Los folletos institucionales fríos no generan conexión emocional.', 'Las charlas teóricas sin dinámicas prácticas no abren el diálogo.'];
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-113" data-mp="2gekapac0k18j">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-114" data-mp="2gczgxmxiwmbq">
        <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-amber-700" data-id="element-115" data-mp="21p4ma0zyg7w0">
          El Problema Real
        </p>
        <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-night md:text-5xl" data-id="element-116" data-mp="26ihc2egdekqc">
          Tenés la intención.{' '}
          <span className="bg-amber-400 px-1.5 pb-0.5 text-night" data-id="element-117" data-mp="1wrmn32bqp717">No tenés el material.</span>
        </h2>

        <ul className="mt-11 space-y-4 text-left" data-id="element-118" data-mp="1irk9hsagszrr">
          {frictions.map(item => <li key={item} className="flex items-start gap-4 border-l-4 border-amber-300 bg-canvas px-5 py-4 text-lg text-gray-700 md:px-6 md:text-xl" data-id="element-119" data-mp="1notvsz2k4vbd">
              {item}
            </li>)}
        </ul>

        <p className="mt-11 font-display text-2xl font-extrabold leading-snug tracking-tight text-night md:text-3xl" data-id="element-120" data-mp="12ad4ucmk7964">
          El tiempo se acaba. Los costos suben. Y el silencio sigue siendo el enemigo.
        </p>
      </div>
    </section>;
}